const initialLetters = [
  { id: 0, subject: 'Ready for adventure?' },
  { id: 1, subject: 'Time to check in!' },
  { id: 2, subject: 'Festival Begins In Just SEVEN Days!' },
];

const initialLettersStarred = [
  { id: 0, subject: 'Ready for adventure?', isStarred: true },
  { id: 1, subject: 'Time to check in!', isStarred: false },
  { id: 2, subject: 'Festival Begins In Just SEVEN Days!', isStarred: false },
];

export { initialLetters, initialLettersStarred };
